import { render } from "./PhoneOutline.vue?vue&type=template&id=778a2b99"
import script from "./PhoneOutline.vue?vue&type=script&lang=js"
export * from "./PhoneOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__